<div class="row" *ngIf="actionSetting$ | async as actionSettings">
   <div class="k-form-field">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%" for="{{ actionId }}-request-user-status">
         {{ 'user_actions.types.request_user_status.settings.state' | translate }}
      </label>
      <kendo-dropdownlist
         fxFlex="60%"
         id="{{ actionId }}-request-user-status"
         [value]="actionSettings.requestUserStatus"
         [data]="samwinUserStates$ | async"
         [valuePrimitive]="true"
         valueField="id"
         textField="name"
         (valueChange)="requestUserStatusChanged(actionSettings, $event)"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            <samweb-agent-status *ngIf="dataItem" [statusInfo]="dataItem"></samweb-agent-status>
         </ng-template>
      </kendo-dropdownlist>
   </div>
</div>
